import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", null, [$props.field.compt === 'editinput' ? (_openBlock(), _createBlock(_component_el_form_item, {
    key: 0
  }, {
    label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.field.label), 1)]),
    default: _withCtx(() => [_createVNode(_component_el_input, {
      modelValue: $data.editinput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.editinput = $event),
      style: {
        "width": "100px"
      }
    }, null, 8, ["modelValue"])]),
    _: 1
  })) : _createCommentVNode("", true), $props.field.compt === 'selectbox' ? (_openBlock(), _createBlock(_component_el_form_item, {
    key: 1
  }, {
    label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.field.label), 1)]),
    default: _withCtx(() => [_createVNode(_component_el_select, {
      modelValue: $data.selectbox,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.selectbox = $event),
      placeholder: "请输入",
      style: {
        "width": "100px"
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.field.options, item => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.title,
          label: item.title,
          value: item.title
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}